import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCart } from './CartContext';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { cart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const freshaBookingUrl = "https://www.fresha.com/a/zoteya-beauty-salon-sandton-33-wessel-road-bw27doko?pId=2602836";
  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);

  // Scroll-to-section navigation
  const handleNavSection = (sectionId) => {
    setMobileMenuOpen(false);
    if (location.pathname === "/") {
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 40);
    } else {
      navigate("/", { state: { scrollTo: sectionId } });
    }
  };

  return (
    <nav
      className="navbar navbar-expand-md py-2 shadow"
      style={{
        background: "#100e0c",
        borderBottom: "3px solid #d4c4a8",
        boxShadow: "0 2.5px 13px #33270f18",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1100,
        minHeight: 0
      }}
    >
      <div className="container">
        <Link
          className="navbar-brand fw-bold"
          style={{
            color: '#d4c4a8',
            letterSpacing: '.055em',
            fontFamily: "'Playfair Display',serif",
            fontSize: '1.12rem',
            padding: "0.1em 0"
          }}
          to="/"
          onClick={() => setMobileMenuOpen(false)}
        >
          Zoteya
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(open => !open)}
          style={{ padding: "4px 12px", fontSize: "1.13em" }}
        >
          <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }} />
        </button>
        <div className={`collapse navbar-collapse${mobileMenuOpen ? " show" : ""}`} id="navMain">
          <ul className="navbar-nav me-auto mb-2 mb-md-0 fw-medium">
            <li className="nav-item">
              <a
                className="nav-link"
                href="/"
                style={{ color: "#fff", fontWeight: 500, fontSize: ".99rem", letterSpacing: ".045em", padding: "0.2em 0.8em" }}
                onClick={e => {
                  e.preventDefault();
                  setMobileMenuOpen(false);
                  if (location.pathname !== "/") {
                    navigate("/");
                  } else {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
              >
                Home
              </a>
            </li>
            {/* All main sections use this scroll mechanism */}
            {[
              { id: "about", label: "About" },
              { id: "services", label: "Services" },
              { id: "products", label: "Products" },
              { id: "stylists", label: "Stylists" },
              { id: "testimonials", label: "Testimonials" },
            ].map(section => (
              <li className="nav-item" key={section.id}>
                <a
                  className="nav-link"
                  href={`#${section.id}`}
                  style={{ color: "#fff", fontWeight: 500, fontSize: ".99rem", padding: "0.2em 0.8em" }}
                  onClick={e => {
                    e.preventDefault();
                    handleNavSection(section.id);
                  }}
                >
                  {section.label}
                </a>
              </li>
            ))}
            <li className="nav-item">
              <Link
                className="nav-link"
                style={{ color: "#fff", fontWeight: 500, fontSize: ".99rem", padding: "0.2em 0.8em" }}
                to="/hair-price-list"
                onClick={() => setMobileMenuOpen(false)}
              >
                Hair Price List
              </Link>
            </li>
          </ul>
          <div className="d-flex align-items-center gap-2">
            {/* Cart */}
            <button
              onClick={() => {
                setMobileMenuOpen(false);
                navigate('/checkout');
              }}
              className="btn position-relative me-2 bg-transparent border-0"
              style={{ padding: '3px 9px' }}
            >
              <i className="bi bi-cart" style={{ fontSize: '1.18rem', color: "#d4c4a8" }}></i>
              {cartCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                  style={{ fontSize: ".79em", padding: "3px 6px" }}>
                  {cartCount}
                </span>
              )}
            </button>
            {/* Book Now */}
            <a
              href={freshaBookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn px-3 py-1 rounded-pill fw-medium"
              style={{
                background: '#d4c4a8',
                color: '#181308',
                fontWeight: 700,
                fontSize: ".96rem",
                letterSpacing: ".07em",
                boxShadow: "0 1.5px 8px #baa56017",
                transition: "background 0.2s, color 0.2s",
                minHeight: 0
              }}
              onMouseOver={e => { e.currentTarget.style.background = "#cab27c"; e.currentTarget.style.color = "#000"; }}
              onMouseOut={e => { e.currentTarget.style.background = "#d4c4a8"; e.currentTarget.style.color = "#181308"; }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Book Now
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
